import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const SkeletonWrapper = styled.section`
  padding-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex¸;
  background-color: ${COLORS.grey5};
  flex: 1;
  height: 100vh;
  /* width: 100%; */
`;

export const SkeletonHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .title {
    margin: 0 0 12px 0;
    width: 220px;
  }

  .header {
    margin: 0 0 12px 0;
    width: 220px;
  }
  .description {
    margin: 6px 0 0 0;
    width: 340px;
  }
  @media ${device.mobileL} {
    width: 94%;
    .header {
      margin: 0 0 12px 0;
      width: 320px;
    }
    .description {
      margin: 6px 0 0 0;
      width: 570px;
    }
  }
  @media ${device.laptop} {
    width: 74%;
    .header {
      margin: 4px 0 16px 0;
      width: 420px;
    }
    .description {
      margin: 4px 0 4px 0;
      width: 600px;
    }
  }
  @media ${device.laptopL} {
    width: 90%;
    .description {
      width: 700px;
    }
  }
`;

export const SkeletonFiltersWrapper = styled.div`
  width: 82%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
  gap: 60px;
  .filter {
    width: 92px;
  }
  .skipTo {
    width: 185px;
  }
  @media ${device.mobileL} {
    width: 35%;
  }
  @media ${device.laptop} {
    justify-content: flex-start;
    gap: 220px;
    .filter {
      width: 176px;
    }
    .skipTo {
      width: 385px;
    }
  }
  @media ${device.desktop} {
    gap: 480px;
  }
`;

export const SkeletonFeaturedOffersTitle = styled.div`
  width: 20%;
  padding-top: 52px;
`;

export const SkeletonFeaturedOffers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 90%;
  padding-top: 36px;

  .title {
    width: 176px;
    margin-bottom: 32px;
  }
  .tile {
    width: 340px;
  }
  .selector {
    width: 340px;
    margin-bottom: 16px;
    /* margin-top: 16px; */
  }
  @media ${device.laptop} {
    /* margin-top: 40px;
    padding-top: 60px; */
    /* border-top: 1px solid #d9d9d9; */
    .title {
      width: 176px;
      margin-bottom: 32px;
    }
    .tile {
      width: 640px;
    }
    .selector {
      margin-bottom: 0;
      width: 480px;
      margin-top: 16px;
    }
  }
`;

export const SkeletonFeaturedOffersSelector = styled.div`
  width: 496px;
  padding-top: 24px;
`;
